import { useLocation } from 'react-router-dom';

import { useEffect, useState } from 'react';

import { GetPaginatedFilteredContractsVariables } 
  from '@/graphql/contracts/_generated_/getPaginatedFilteredContracts.query';
import useGetPrevNextContractIds 
  from '@/hooks/contract/useGetPrevNextContractIds.hook';
import { getSubscriptionId } from '@/utils/auth/subscription.utils';
import { CURRENT_CONTRACTS_QUERY } from '@/config/storage.config';


const usePrevNextContractIds = (contractId: string) => {

  const location = useLocation();
  const { getPrevNextContractIds } = useGetPrevNextContractIds();
  const [data, setData] = useState<{
    rowIndex: number,
    contractID: string,
    prevID: string | null | undefined,
    nextID: string | null | undefined
  }>();
  
  useEffect(() =>{
    const rowIndex = Number(new URLSearchParams(location.search).get('rowIndex') ?? undefined);

    if (Number.isNaN(rowIndex)) {
      return;
    }
    const getDataFilter = async () => {
      let res;
      try {
        const subscriptionId = await getSubscriptionId();
        const value = localStorage.getItem(CURRENT_CONTRACTS_QUERY + ':' + subscriptionId);
        res = value !== null ? JSON.parse(value) : undefined;
      }
      catch {
        res = undefined;
      }
      if (!res) {
        return undefined;
      }
      const dataFilter = res as GetPaginatedFilteredContractsVariables;
      return { 
        contractId, 
        rowIndex, 
        filter: dataFilter?.filter,
        sort: dataFilter?.sort,
      };
    };

    getDataFilter()
      .then((dataFilter) => {
        if (!dataFilter) {
          setData({
            rowIndex,
            contractID: contractId,
            prevID: undefined,
            nextID: undefined
          });
          return;
        }
        getPrevNextContractIds(dataFilter!)
          .then((res) => 
          {
            const resData = res.prevNextContractIds;
            setData({
              rowIndex,
              contractID: resData.contractID,
              prevID: resData.prevID,
              nextID: resData.nextID
            });
          }
          );
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractId]);
  return data;
};

export default usePrevNextContractIds;
